import { getExpiringInDays } from "../../../../../common/helper";
import ChartIcon from "../../../../components/Icons/ChartIcon";
import ClockIcon from "../../../../components/Icons/ClockIcon";
import DollarIcon from "../../../../components/Icons/DollarIcon";

export default function Meta({ meta }) {
    const rok = getExpiringInDays(meta.expiresAt);
    return (
        <div className=" bg-gray-light">
            <div className="max-w-screen-md mx-auto pt-16 pb-8 px-6 md:px-0 text-center">
                <div
                    className={`grid grid-cols-2 md:grid-cols-3 ${
                        meta.sallary ? "lg:grid-cols-4" : "lg:grid-cols-3"
                    } gap-4 w-full`}
                >
                    <div className="">
                        <div className="flex justify-center text-gray-dark text-sm">
                            <ChartIcon />
                            <div>Iskustvo</div>
                        </div>
                        <div className="mt-2 font-medium">{meta.level}</div>
                    </div>
                    {/* <div className="">
                        <div className="flex justify-center text-gray-dark text-sm">
                            <BriefIcon />
                            <div>Pozicija</div>
                        </div>
                        <div className="mt-2 font-medium">
                            {meta.department}
                        </div>
                    </div> */}
                    <div className="">
                        <div className="flex justify-center text-gray-dark text-sm">
                            <ClockIcon />
                            <div>Angažman</div>
                        </div>
                        <div className="mt-2 font-medium">{meta.type}</div>
                    </div>
                    {meta.sallary && (
                        <div className="">
                            <div className="flex justify-center text-gray-dark text-sm">
                                <DollarIcon />
                                <div>Plata</div>
                            </div>
                            <div className="mt-2 font-medium">
                                {meta.sallary}
                            </div>
                        </div>
                    )}
                    <div className="">
                        <div className="flex justify-center text-gray-dark text-sm">
                            <ChartIcon />
                            <div>Rok prijave</div>
                        </div>
                        <div
                            className={`mt-2 font-medium ${
                                rok.type === "istekao" && "text-red"
                            }`}
                        >
                            {rok.type === "istekao"
                                ? "Istekao"
                                : `još ${rok.days} dana`}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
